/**
 * Geolocation shared by the location v2 finder and store header.
 * Does not prompt on load. A granted permission refreshes the cached fix.
 * Pandectes cookie _pandectes_gdpr status 7 is a full deny.
 */
(function (root) {
  "use strict";

  var STORAGE_KEY = "kah-geo";

  function read() {
    try {
      var raw = root.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !Number.isFinite(parsed.lat) || !Number.isFinite(parsed.lng)) return null;
      return parsed;
    } catch (error) {
      return null;
    }
  }

  function write(pos) {
    try {
      root.localStorage.setItem(STORAGE_KEY, JSON.stringify(pos));
    } catch (error) {
      /* private mode */
    }
  }

  function emit(pos) {
    root.dispatchEvent(new CustomEvent("kah:geo", { detail: pos }));
  }

  function consentDenied() {
    var match = root.document.cookie.match(/(?:^|; )_pandectes_gdpr=([^;]*)/);
    if (!match) return false;
    var value = decodeURIComponent(match[1]);
    return value === "7" || value.indexOf('"status":7') !== -1;
  }

  function storePosition(position) {
    var pos = {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
      ts: Date.now(),
    };
    write(pos);
    emit(pos);
    return pos;
  }

  function request() {
    if (consentDenied()) return Promise.resolve(null);
    if (!root.navigator.geolocation) return Promise.resolve(null);
    return new Promise(function (resolve) {
      root.navigator.geolocation.getCurrentPosition(
        function (position) {
          resolve(storePosition(position));
        },
        function () {
          resolve(null);
        },
        { enableHighAccuracy: false, maximumAge: 300000, timeout: 8000 }
      );
    });
  }

  function refreshIfGranted() {
    if (consentDenied() || !root.navigator.permissions || !root.navigator.permissions.query) return;
    root.navigator.permissions
      .query({ name: "geolocation" })
      .then(function (status) {
        if (status.state === "granted") request();
      })
      .catch(function () {});
  }

  root.KahGeo = {
    get: read,
    request: request,
    consentDenied: consentDenied,
  };

  refreshIfGranted();
})(window);
